import type { campaignsSlice } from './CampaignsSlice';
import type { metaSlice } from './MetaSlice';
import type { portfolioSlice } from './PortfolioSlice';
import type { profileSlice } from './ProfileSlice';
import type { settingsSlice } from './SettingsSlice';
import type { statusSlice } from './StatusSlice';
import type { widgetSlice } from './WidgetSlice';
import type { Slice } from '@reduxjs/toolkit';

import { combineReducers } from '@reduxjs/toolkit';

import { CampaignsReducer } from './CampaignsSlice';
import { MetaReducer } from './MetaSlice';
import { PersistedPortfolioReducer } from './PortfolioSlice';
import { ProfileReducer } from './ProfileSlice';
import { SettingsReducer } from './SettingsSlice';
import { StatusReducer } from './StatusSlice';
import { WalletDetailsReducer } from './WalletDetailsSlice';
import { WidgetReducer } from './WidgetSlice';

type ActionsFromSlice<T extends Slice> = ReturnType<T['actions'][keyof T['actions']]>;

export type RootActions =
  | ActionsFromSlice<typeof metaSlice>
  | ActionsFromSlice<typeof statusSlice>
  | ActionsFromSlice<typeof profileSlice>
  | ActionsFromSlice<typeof campaignsSlice>
  | ActionsFromSlice<typeof widgetSlice>
  | ActionsFromSlice<typeof settingsSlice>
  | ActionsFromSlice<typeof portfolioSlice>;

const rootReducer = combineReducers({
  meta: MetaReducer,
  status: StatusReducer,
  profile: ProfileReducer,
  campaign: CampaignsReducer,
  widget: WidgetReducer,
  settings: SettingsReducer,
  walletDetails: WalletDetailsReducer,
  portfolio: PersistedPortfolioReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
